interface UIUserInterface {
  declaration: {
    report: string;
  };
}

const defaultUIUserInterface: UIUserInterface = {
  declaration: {
    report: 'REPORT',
  },
};

export { defaultUIUserInterface };

export default UIUserInterface;
